import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';

export default function Nav() {
  const { currentUser } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/');
  };

  return (
    <nav style={styles.nav}>
      <div style={styles.logo} onClick={() => navigate('/')}>
        U<span style={styles.dot}>.</span>creative
      </div>
      <div style={styles.links}>
        <span style={styles.link} onClick={() => navigate('/')}>Accueil</span>
        <span style={styles.link} onClick={() => navigate('/contact')}>Contact</span>
        {currentUser ? (
          <>
            <span style={styles.link} onClick={() => navigate('/dashboard')}>Dashboard</span>
            <button style={styles.btn} onClick={handleLogout}>Déconnexion</button>
          </>
        ) : (
          <button style={styles.btn} onClick={() => navigate('/auth')}>Connexion</button>
        )}
      </div>
    </nav>
  );
}

const styles = {
  nav: {
    position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
    padding: '20px 40px', display: 'flex', alignItems: 'center',
    justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.08)',
    background: 'rgba(8,8,8,0.85)', backdropFilter: 'blur(20px)',
  },
  logo: {
    fontFamily: 'sans-serif', fontWeight: 800, fontSize: '1.4rem',
    letterSpacing: '-0.03em', cursor: 'pointer', color: '#F0F0F0',
  },
  dot: { color: '#3b82f6' },
  links: { display: 'flex', gap: '32px', alignItems: 'center' },
  link: { color: '#888', textDecoration: 'none', fontSize: '0.9rem', cursor: 'pointer' },
  btn: {
    background: '#3b82f6', color: '#000', border: 'none',
    padding: '10px 24px', borderRadius: '100px', fontWeight: 700,
    fontSize: '0.85rem', cursor: 'pointer',
  },
};
